module.exports = __webpack_public_path__ + "static/media/start_quote.c2148afa.mp4";